import { EAppInitialStatus } from "../../models";

const defaultState = {
  initializeStatus: EAppInitialStatus.PENDING,
  isForbidden: false,
  isUnauthorized: false,
  isExpiredToken: false,
};

export const SET_INITIALIZE_STATUS = "SET_INITIALIZE_STATUS";
export const SET_FORBIDDEN_ERROR = "SET_FORBIDDEN_ERROR";
export const SET_UNAUTHORIZED_ERROR = "SET_UNAUTHORIZED_ERROR";
export const SET_EXPIRED_TOKEN_ERROR = "SET_EXPIRED_TOKEN_ERROR";

export const mainReducer = (state = defaultState, action: any) => {
  const { type, status } = action;
  if (type === SET_INITIALIZE_STATUS)
    return { ...state, initializeStatus: status };
  if (type === SET_FORBIDDEN_ERROR) return { ...state, isForbidden: status };
  if (type === SET_UNAUTHORIZED_ERROR)
    return { ...state, isUnauthorized: status };
  if (type === SET_EXPIRED_TOKEN_ERROR)
    return { ...state, isExpiredToken: status };
  return state;
};
